/* Progressive enhancement: all navigation links also work without JavaScript. */
(() => {
  const nav = document.querySelector('.norla-mobile-nav');
  if (!nav) return;
  nav.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-norla-action]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const action = link.dataset.norlaAction;
    const target = action === 'search' ? document.querySelector('#search-modal') :
      action === 'cart' ? document.querySelector('cart-drawer-component') : null;
    if (target && typeof target.showDialog === 'function') {
      event.preventDefault();
      target.showDialog();
    }
  });
  let refresh;
  let controller;
  const updateCount = (count) => {
    if (!Number.isFinite(count)) return;
    const badge = nav.querySelector('[data-norla-cart-count]');
    badge.textContent = String(count);
    badge.hidden = count === 0;
  };
  document.addEventListener('cart:update', (event) => {
    clearTimeout(refresh);
    controller?.abort();
    const count = event.detail?.resource?.item_count;
    if (Number.isFinite(count)) return updateCount(count);
    refresh = setTimeout(async () => {
      controller = new AbortController();
      try {
        const response = await fetch(nav.dataset.cartUrl, {signal:controller.signal, headers:{Accept:'application/json'}});
        if (response.ok) updateCount((await response.json()).item_count);
      } catch { /* Keep the last known count if the network is unavailable. */ }
    }, 150);
  });
  const updateKeyboard = () => {
    const typing = document.activeElement?.matches('input:not([type=checkbox]):not([type=radio]), textarea, [contenteditable=true]');
    document.body.classList.toggle('norla-keyboard-open', Boolean(typing && window.visualViewport && window.innerHeight - window.visualViewport.height > 120));
  };
  window.visualViewport?.addEventListener('resize', updateKeyboard);
  document.addEventListener('focusin', updateKeyboard);
  document.addEventListener('focusout', () => requestAnimationFrame(updateKeyboard));
})();
